import Head from 'next/head';
import SiteLayout from '@/components/layout/SiteLayout';
import { PortraitSection } from '@/components/sections/PortraitSection';
import { portraitEintraege } from '@/lib/content/texte';

const seo = {
  title: 'Marlene Gujan Architektur AG | Portrait',
  description: 'Lernen Sie Marlene Gujan und die Geschichte der Marlene Gujan Architektur AG in Igis kennen. Erfahren Sie mehr über unsere Vision und Werte.',
  keywords: 'Portrait, Marlene Gujan, Architektur, Igis, Vision, Werte, Geschichte',
  canonicalUrl: 'https://www.gujan-architektur.ch/buero/portrait',
};

export default function Portrait({ data }) {
  return (
    <SiteLayout>
      <Head>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <link rel="canonical" href={seo.canonicalUrl} />
      </Head>
      <PortraitSection data={data} />
    </SiteLayout>
  );
}

export async function getStaticProps() {
  return { props: { data: await portraitEintraege() }, revalidate: 300 };
}
